/* src/app/umbrella-common/cookies-banner/banner-link/banner-link.component.scss */
a {
  color: #fff;
  text-decoration: underline;
  background-color: transparent;
}
/*# sourceMappingURL=banner-link.component.css.map */
